<script>
import { mapGetters } from 'vuex';
import ContactForm from './ContactForm.vue';

export default {
  components: {
    ContactForm,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    contact: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['cancel', 'update:show'],
  data() {
    return {
      frozenContact: null,
      isModalOpen: false,
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'contacts/getUIFlags',
    }),
    localShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      },
    },
    activeContact() {
      if (this.isModalOpen && this.frozenContact) {
        return this.frozenContact;
      }
      return this.contact;
    },
  },
  watch: {
    show: {
      immediate: true, 
      handler(newVal, oldVal) {
        
        // Solo actuar cuando cambia de false a true o viceversa
        if (newVal && !this.isModalOpen) {
          // Se está abriendo
          this.isModalOpen = true;
          
          this.$nextTick(() => {
            this.frozenContact = JSON.parse(JSON.stringify(this.contact));
          });
        } else if (!newVal && this.isModalOpen) {
          // Se está cerrando
          this.isModalOpen = false;
          this.frozenContact = null;
        }
      },
    },
    contact: {
      handler(newVal) {
        
      },
      deep: true
    }
  },
  methods: {
    onCancel() {
      this.$emit('cancel');
    },
    onSuccess() {
      this.$emit('cancel');
    },
    async onSubmit(contactItem) {
      await this.$store.dispatch('contacts/update', contactItem);
      await this.$store.dispatch(
        'contacts/fetchContactableInbox',
        this.contact.id
      );
    },
  },
};
</script>

<template>
  <woot-modal
    v-model:show="localShow"
    :on-close="onCancel"
    modal-type="right-aligned"
  >
    <div class="flex flex-col h-auto overflow-auto">
      <woot-modal-header
        :header-title="`${$t('EDIT_CONTACT.TITLE')} - ${
          activeContact.name || activeContact.email
        }`"
        :header-content="$t('EDIT_CONTACT.DESC')"
      />
      <ContactForm
        :contact="activeContact"
        :in-progress="uiFlags.isUpdating"
        :on-submit="onSubmit"
        @success="onSuccess"
        @cancel="onCancel"
      />
    </div>
  </woot-modal>
</template>